/* This file is autogenerated, see readme.md for instructions */
import PersAlt2SvgIcon from '@bloomreach/banana-theme/icons/pers-alt-2.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PersAlt2Icon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PersAlt2SvgIcon />
    </Icon>
  );
});

PersAlt2Icon.displayName = 'PersAlt2Icon';

export default PersAlt2Icon;
